<script setup>
import { getI18n } from '@/plugins/i18n'

import { useODataSource } from '@/composables/data-grid'
import { useRegistryStore } from '@/stores/registry.store'
import { useFocusRestore } from '@/composables/focus-restore'
import { menuRoutesEnum } from '@/router'

import GridDropDownBox from '@/components/shared/GridDropDownBox.vue'

const emit = defineEmits({
  valueChanged: (e) => true,
})
const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  showClearButton: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  exclude: {
    type: Number,
    required: false,
  },
  value: {
    type: Number,
    default: null,
  },
})

const registryStore = useRegistryStore()
const i18n = getI18n()

const defaultDataSource = useODataSource(registryStore.api.getAbsoluteUrl() + registryStore.api.customersSearchUrl, {
  filter: props.exclude ? ['id', '<>', props.exclude] : null,
  searchExpr: ['name', 'name_ext', 'full_name', 'code'],
})

const valueChanged = (e) => {
  emit('valueChanged', { value: e })
  if (typeof props.data?.setValue === 'function') {
    props.data.setValue(e)
  }
}

const { rootRef } = useFocusRestore('customer')
</script>

<template>
  <div ref="rootRef">
    <grid-drop-down-box
      :disabled="props.disabled"
      :value="props.value || props.data?.value"
      :data-source="defaultDataSource"
      :show-clear-button="props.showClearButton"
      :columns="[
        { dataField: 'code', caption: $t('common.code'), width: '5rem' },
        {
          dataField: 'privacy_check', caption: $t('common.privacy'), cellTemplate: 'cellTemplate-privacy_check', width: '5rem'
        },
        {
          dataField: 'name', caption: $t('common.name'),
          calculateCellValue: (rowData) => {
            let name = rowData.name
            if (rowData.name_ext) { name += ` ${rowData.name_ext}` }
            return name
          },
        },
        { dataField: 'phone', caption: $t('common.phone') },
        { dataField: 'vat_number', caption: $t('common.vatNumber') },
        { dataField: 'tax_code', caption: $t('common.taxCode') },
        { dataField: 'address.city_name', caption: $t('common.city') },
        { dataField: 'address.street', caption: $t('common.street') },
      ]"
      :drop-down-options="{ width: '56rem', height: '30rem' }"
      :options="{ target: menuRoutesEnum.SUBJECTS, routeParam: props.data?.data?.customer?.code }"
      @value-changed="valueChanged"
    >
      <template #cellTemplate-privacy_check="{ data: templateData }">
        <q-chip
          v-if="!templateData.data.privacy_check"
          size="sm"
          text-color="white"
          style="margin: 0"
          :label="i18n.t('common.privacy')"
          color="red"
        />
      </template>
    </grid-drop-down-box>
  </div>
</template>
